export default __webpack_public_path__ + "static/media/card2.8c9357f7.jpg";